import React from 'react'
import Button from '../../../components/buttons/buttons.component'
import styled from 'styled-components'
import AccordionSecondary from './../../../components/accordion/accordion-secondary.component'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import PaymentDataConfirmation from './payment-data-confirmation.component'
import PromotionDataConfirmation from './promotion-data-confirmation.component'
import OrderSummaryConfirmation from './order-summary-confirmation.component'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import { connect } from 'react-redux'
import { history } from './../../../helpers/history'
import PromotionCouponService from '../../../services/promotion-coupon.service'
import { PAYMENT_METHODS } from '../../../constants'
import { toastActions } from '../../../actions'
import { downloadFromURL } from '../../../helpers/download.helper'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import FontAwesome from 'react-fontawesome'
import { ClientTicketService } from '../../../services/client-ticket.service'
import FileSaver from 'file-saver'
import PixInfo from '../../../components/pix/pix-info.component'

class ConfirmationStepComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			message: '',
			isPromotionLoaded: false,
		}

		this.getAccordionItems = getAccordionItems.bind(this)
		this.getPromotionCouponMessage = getPromotionCouponMessage.bind(this)
		this.promotionCouponControl = promotionCouponControl.bind(this)
	}
	componentDidMount() {
		if (!this.props.isConfirmationStep) {
			this.setState({ isPromotionLoaded: false, message: '' })
		}
	}

	downloadBpe = async () => {
		const {
			ticketsGoing,
			ticketsReturn,
			orderNumber,
			buyerId,
			user,
			showLoading,
			hideLoading,
			toastDanger,
		} = this.props
		const error = () => {
			toastDanger({
				message: 'Não foi possível fazer o download dos arquivos.',
			})
			hideLoading()
		}
		showLoading()
		ticketsGoing.map((f) => {
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Checkin de Embarque'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Passagem DaBPE'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
		})
		ticketsReturn.map((f) => {
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Checkin de Embarque'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Passagem DaBPE',
				`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
		})
	}

	render() {
		const emv = this.props.pixData ? this.props.pixData.emv : ''
		const qrCodeBase64 = this.props.pixData
			? this.props.pixData.qrCodeBase64
			: ''
		const pixLink = this.props.pixData ? this.props.pixData.pixLink : ''
		const pixExpiration =
			this.props.pixData && this.props.pixData.pixExpiration
				? new Date(this.props.pixData.pixExpiration)
				: new Date()

		const notAuthenticated = this.props.user === null
		const bankSlipLink = this.props.bankSlipLink
		const orderNumber = this.props.orderNumber.toString()
		const showBpeDownloadLink = this.props.showBpeDownloadLink
		const renderBankSlipInfo =
			this.props.paymentMethod === PAYMENT_METHODS.BANKSLIP
		const renderPixInfo = this.props.paymentMethod === PAYMENT_METHODS.PIX
		const renderBpeInfo =
			this.props.paymentMethod === PAYMENT_METHODS.CREDIT_CARD ||
			this.props.paymentMethod === PAYMENT_METHODS.ONLINE_DEBT ||
			this.props.paymentMethod === PAYMENT_METHODS.MUVICARD

		this.promotionCouponControl()
		return (
			this.props.isConfirmationStep && (
				<React.Fragment>
					<AccordionSecondary
						multiple
						noAnimated
						noClickable
						arrow={false}
						items={this.getAccordionItems()}
					/>
					<StyledDiv>
						<p style={{ marginBottom: '0' }}>
							<span className="f-x-large orange">
								Um e-mail de confirmação foi enviado para{' '}
								{this.props.buyerEmail || this.props.user.email}!
							</span>
						</p>

						{renderBankSlipInfo && (
							<span className="f-x-large">
								<p className="f-x-large">
									O pagamento do boleto pode levar até 3 dias úteis
									para constar em nosso sistema.
								</p>
								<p className="f-x-large">
									O Não Pagamento ou Pagamentos realizados após o
									vencimento implica no cancelamento automático das
									reservas.
								</p>
								<p className="f-x-large">
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											margin: '4rem auto',
										}}>
										<Button
											primary
											onClick={() => {
												const { showLoading, hideLoading } =
													this.props
												showLoading()

												const downloadPromise = downloadFromURL(
													bankSlipLink,
													`boleto-moveflex-pedido-${orderNumber}.pdf`
												)

												downloadPromise
													.then(() => hideLoading())
													.catch(() => hideLoading())
											}}>
											Imprimir boleto
										</Button>
									</div>
								</p>
							</span>
						)}

						{renderPixInfo && (
							<span className="f-x-large">
								<p className="f-x-large">
									O não pagamento implica no cancelamento automático da
									reserva de passagem.
								</p>
								<PixInfo
									pixImageQrCode={qrCodeBase64}
									pixValidity={pixExpiration}
									pixEmv={emv}
								/>
							</span>
						)}

						{renderBpeInfo &&
							(showBpeDownloadLink ? (
								<span className="f-x-large">
									<br />
									<p className="f-x-large">
										O seu bilhete de passagem foi enviado via e-mail
										ou você pode salvar clicando no botão azul abaixo
										nesta página!
									</p>
									<p className="f-x-large">
										É obrigatório a apresentação do mesmo para
										embarque. A rodoviária não realiza impressão de
										segunda via de bilhete de passagem.
									</p>
									<p>
										<Button
											secondary
											type="button"
											onClick={this.downloadBpe}>
											<span style={{ marginRight: 5 }}>
												<FontAwesome name="qrcode" size="lg" />
											</span>
											<span style={{ marginRight: 5 }}>
												<FontAwesome name="download" size="lg" />
											</span>
											Salvar Passagem(ns) Digital(is)
										</Button>
									</p>
								</span>
							) : (
								<span className="f-x-large">
									<br />
									<p className="f-x-large">
										<b>Para viagens DENTRO DO RS</b>, você receberá
										sua passagem digital e cartão de embarque para
										apresentá-los de forma digital ou impressa
										diretamente no embarque!
									</p>
									<p className="f-x-large">
										<b>Para viagens ENTRE ESTADOS</b>, este documento
										deverá ser apresentado na estação rodoviária de
										embarque ou no guichê da empresa para emissão de
										seu(s) bilhete(s) eletrônico(s).
									</p>
									<p className="f-x-large">
										Também é possível visualizar seu voucher no painel
										do cliente, no menu “Minhas compras”
									</p>
								</span>
							))}

						{notAuthenticated ||
						renderBankSlipInfo ||
						renderPixInfo ? null : (
							<div className="button-container">
								<Button
									primary
									type="button"
									onClick={() =>
										history.push('/cliente/minhas-compras')
									}>
									Minhas passagens
								</Button>
							</div>
						)}
					</StyledDiv>
				</React.Fragment>
			)
		)
	}
}

const StyledDiv = styled.div`
	margin-bottom: 6rem;
	margin-top: 3rem;
	text-align: center;

	.button-container {
		margin-top: 1.5rem;
	}
`

function getAccordionItems() {
	const { installmentsQtt } = this.props
	const orderNumber = this.props.orderNumber.toString()
	const orderNumberLength = 6
	const formattedOrderNumber =
		orderNumber.length > orderNumberLength
			? orderNumber
			: ('0'.repeat(orderNumberLength) + orderNumber).slice(
					-orderNumberLength
			  )

	var accordionArray = [
		{
			title: `Resumo do pedido ${formattedOrderNumber}`,
			initiallyOpened: true,
			content: <OrderSummaryConfirmation />,
		},
	]

	if (installmentsQtt > 0)
		accordionArray.push({
			title: 'Dados do pagamento',
			initiallyOpened: true,
			content: <PaymentDataConfirmation />,
		})

	accordionArray.push({
		title: this.state.message != '' ? 'Promoção' : '',
		initiallyOpened: true,
		content: <PromotionDataConfirmation message={this.state.message} />,
	})
	return accordionArray
}

function getPromotionCouponMessage() {
	const orderNumber = this.props.orderNumber
	const paymentMethod = this.props.paymentMethod

	if (orderNumber > 0 && paymentMethod !== PAYMENT_METHODS.BANKSLIP) {
		PromotionCouponService.getUberCouponByOrderNumber(orderNumber).then(
			({ data }) => {
				data
					? this.setState({ message: data.notes, isPromotionLoaded: true })
					: this.setState({ message: '', isPromotionLoaded: true })
			}
		)
	} else {
		this.setState({ message: '', isPromotionLoaded: true })
	}
}

function promotionCouponControl() {
	if (!this.props.isConfirmationStep) {
		if (this.state.message != '') {
			this.setState({ message: '', isPromotionLoaded: false })
		}
		if (this.state.isPromotionLoaded) {
			this.setState({ isPromotionLoaded: false })
		}
	}

	if (this.props.isConfirmationStep && !this.state.isPromotionLoaded) {
		this.getPromotionCouponMessage()
	}
}

const mapStateToProps = (store) => ({
	user: store.user,
	buyerId: store.ticketSale.buyerId,
	buyerEmail: store.ticketSale.buyerEmail,
	orderNumber: store.ticketSale.orderNumber,
	paymentMethod: store.ticketSale.paymentMethod,
	showBpeDownloadLink: store.ticketSale.showBpeDownloadLink,
	installmentsQtt: CreditCardPurchaseSelectors.getInstallmentsQtt(
		store.creditCardPurchase
	),
	isConfirmationStep: TicketSaleSelectors.isConfirmationStep(store),
	lastFourNumbers: CreditCardPurchaseSelectors.getCardLastFourNumbers(
		store.creditCardPurchase
	),
	bankSlipLink: store.ticketSale.bankSlipLink,
	pixData: store.ticketSale.pixData,
	ticketsGoing: store.ticketSale.confirmedTicketsGoing,
	ticketsReturn: store.ticketSale.confirmedTicketsReturn,
	anticipatedPix: store.ticketSale.anticipatedPix,
})

const mapDispatchToProps = {
	showLoading: SiteCreators.showLoading,
	hideLoading: SiteCreators.hideLoading,
	toastDanger: toastActions.danger,
}

const ConfirmationStep = connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfirmationStepComponent)

export default ConfirmationStep
